// empty phone mask needed in order to prevent ( character from displaying on empty inputs instead of placeholder
export const PhoneMask = [{ mask: '' }, { mask: '(000) 000-0000' }];
export const EinMask = '00-0000000';
export const ForeignEinMask = '0000000000000000000000000';
export const ZipMask = [{ mask: '00000' }];
export const SsnMask = '000-00-0000';
